const conversionFunctions: {
  [key: string]: any;
} = {};

conversionFunctions["astros"] = require("./BASEBALL/astros").default;
conversionFunctions["brewers"] = require("./BASEBALL/brewers").default;
conversionFunctions["marlins"] = require("./BASEBALL/marlins").default;
conversionFunctions["rangers"] = require("./BASEBALL/rangers").default;
conversionFunctions["clippers"] = require("./BASKETBALL/clippers").default;
conversionFunctions["pittsburgh-panthers"] =
  require("./COLLEGE/pittsburgh-panthers").default;
conversionFunctions["windsurge"] =
  require("./MINOR_BASEBALL/windsurge").default;
conversionFunctions["reign"] = require("./MINOR_HOCKEY/reign").default;
conversionFunctions["frontwavearena"] =
  require("./MULTI/frontwavearena").default;
conversionFunctions["la-kings"] = require("./HOCKEY/la-kings").default;
conversionFunctions["fresnogrizzlies"] =
  require("./MINOR_BASEBALL/fresnogrizzlies").default;
conversionFunctions["66ers"] = require("./MINOR_BASEBALL/66ers").default;
conversionFunctions["greenjackets"] =
  require("./MINOR_BASEBALL/greenjackets").default;
conversionFunctions["barons"] = require("./MINOR_BASEBALL/barons").default;
conversionFunctions["towerbuzzers"] =
  require("./MINOR_BASEBALL/towerbuzzers").default;
conversionFunctions["woosox"] = require("./MINOR_BASEBALL/woosox").default;
conversionFunctions["cyclones"] = require("./MINOR_BASEBALL/cyclones").default;
conversionFunctions["saintsbaseball"] =
  require("./MINOR_BASEBALL/saintsbaseball").default;
conversionFunctions["jumboshrimp"] =
  require("./MINOR_BASEBALL/jumboshrimp").default;
conversionFunctions["rubberducks"] =
  require("./MINOR_BASEBALL/rubberducks").default;
conversionFunctions["fishercats"] =
  require("./MINOR_BASEBALL/fishercats").default;
conversionFunctions["stormers"] = require("./MINOR_BASEBALL/stormers").default;
conversionFunctions["spartanburgers"] =
  require("./MINOR_BASEBALL/spartanburgers").default;
conversionFunctions["rcquakes"] = require("./MINOR_BASEBALL/rcquakes").default;
conversionFunctions["stripers"] = require("./MINOR_BASEBALL/stripers").default;
conversionFunctions["bats"] = require("./MINOR_BASEBALL/bats").default;
conversionFunctions["railriders"] =
  require("./MINOR_BASEBALL/railriders").default;
conversionFunctions["hvrenegades"] =
  require("./MINOR_BASEBALL/hvrenegades").default;
conversionFunctions["frednats"] = require("./MINOR_BASEBALL/frednats").default;
conversionFunctions["okccomets"] =
  require("./MINOR_BASEBALL/okccomets").default;
conversionFunctions["stormchasers"] =
  require("./MINOR_BASEBALL/stormchasers").default;
conversionFunctions["charlotteknights"] =
  require("./MINOR_BASEBALL/charlotteknights").default;
conversionFunctions["drillers"] = require("./MINOR_BASEBALL/drillers").default;
export default conversionFunctions;
